<template>
  <div>
    <header>
      <p v-on:click="backHistory" style="padding-left: 0; " @click="">
        <img src="@/assets/img/back.png" alt="">
        <span style="color: #FFFFFF">职位详情</span>

      </p>
    </header>
    <div class="positionMain" style="margin-top: 5.5rem;padding-bottom: 5rem">
      <!--<router-link to="/detailsPosition">-->
      <div class="conmDetail" style="border-bottom: solid 1px #DEDEDE">
        <div class="recommend">
          <div class="recommendTop">
            <span>{{list.name}}</span>
            <span class="recommendTopSpan">普通职位</span>
          </div>
          <div class="recommendG">
            <span class="recommendYear">{{list.city}}</span>
            <span class="recommendYear" v-if="list.work_year==1">不限</span>
            <span class="recommendYear" v-else-if="list.work_year==2" >1年以下</span>
            <span class="recommendYear" v-else-if="list.work_year==3" >1-3年</span>
            <span class="recommendYear" v-else-if="list.work_year==4" >3-5年</span>
            <span class="recommendYear" v-else-if="list.work_year==5" >5-10年</span>
            <span class="recommendYear" v-else-if="list.work_year==6" >10年以上</span>
            <span class="recommendYear" v-if="list.edu==1">/不限</span>
            <span class="recommendYear" v-else-if="list.edu==2" >/大专</span>
            <span class="recommendYear" v-else-if="list.edu==3" >/本科</span>
            <span class="recommendYear" v-else-if="list.edu==4" >/硕士</span>
            <span class="recommendYear" v-else-if="list.edu==5" >/博士</span>
            <!--<span class="recommendYear">3-5K</span>-->
            <!--<span v-if="list.salary==1">1K-2K</span>-->
            <!--<span v-else-if="list.salary==2">2K-4K</span>-->
            <!--<span v-else-if="list.salary==3">4K-6K</span>-->
            <!--<span v-else-if="list.salary==4">6K-8K</span>-->
            <!--<span v-else-if="list.salary==5">8K-10K</span>-->
            <!--<span v-else-if="list.salary==6">10K-15K</span>-->
            <!--<span v-else-if="list.salary==7">15K-20K</span>-->
            <!--<span v-else-if="list.salary==8">20K-25K</span>-->
            <!--<span v-else-if="list.salary==9">25K-35K</span>-->
            <!--<span v-else-if="list.salary==10">35K-50K</span>-->
            <!--<span v-else-if="list.salary==11">50K-70K</span>-->
            <!--<span v-else-if="list.salary==12">70K-100K</span>-->
            <!--<span v-else-if="list.salary==13">100K以上</span>-->
            <span class="recommendYear" v-if="list.work_nature==1">/全职</span>
            <span v-else-if="list.work_nature==2">/兼职</span>
            <span v-else-if="list.work_nature==3">/实习</span>
          </div>
          <div style="font-size: 13px" class="salaryDiv" >
            <!--<div>-->
              <span class="recommendTopK">{{qwxz}} </span>
            <!--</div>-->
            <!--<div>朝阳区·高碑店</div>-->
          </div>
          <div class="cityDiv">
            <span>北京朝阳区</span>
            <span>大望路SHOH</span>
          </div>
        </div>
      </div>
      <div  class="personalTop">
        <h3>职位描述</h3>
        <p class="personalTopS">
          <!--<van-icon name="location-o" />-->
          <span>{{list.keywords}}</span>
          <!--<span>-->
            <!--&lt;!&ndash;<van-icon name="shop-o" />&ndash;&gt;-->
            <!--电商</span>-->
        </p>
        <p style="font-size: 14px">{{list.desc}}</p>
      </div>
      <div  style="width: 90%;margin: auto">
        <h3>职位Leader</h3>
        <div class="leaderDiv">
          <div class="Leader">
            <div>
              <span class="personalTopNmae">{{leader.nickName}}</span>
              <span class="" style="font-size: 12px;color: #8f8f94">{{list.leader.positions}}</span>
            </div>
            <div class="comPosition" >
              <img src="@/assets/img/tx.jpg" alt="">
            </div>
          </div>
          <!--<router-link to="/positionLeader">-->
          <p class="LeaderB" @click="toleader(list.id)">编辑</p>
          <!--</router-link>-->
          <div class="LeaderL">

            <span>Leader亮点</span>
            <span style="color: #8f8f94;font-size: 12px">{{list.welfare}}</span>
            <span style="margin-top: 1rem">管理风格</span>
            <span style="color: #8f8f94;font-size: 12px">{{leader.leader_style}}</span>
          </div>
        </div>

      </div>

    </div>

    <div class="bottom">
      <!--<router-link to="/remPosition">-->
      <p class="" @click="toRemPosition(list.id)">编辑</p>
      <!--</router-link>-->
      <p class="" @click="saveJobStater()">下线</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'position',
    data () {
      return {
        msg: '',
        list:{
          leader:{

          }
        },
        leader:{},
        qwxz:""
      }
    },
    mounted(){
//      this.getPositioner()
      this.getComPositioner()

    },
    methods:{
      backHistory(){
        this.$router.push("/comPosition")
      },
      toleader(id){
        this.$router.push({
          path:"/positionLeader",
          query:{
            id:id
          }
        })
      },
      toRemPosition(id){
        this.$router.push({
          path: "/remPosition",
          query:{
            id:id
          }
        })
      },
      saveJobStater(){
        this.$api.saveJobState({
          "state":2,
          "jobid":this.$route.query.id
        })
          .then(res=>{
            if (res.status==200){
              this.$router.push("/comPosition")
              this.$toast("下线成功")
            }
          })
      },
      getComPositioner(){
        this.$api.getComPosition({
          "jobid":this.$route.query.id,
//          "id":this.$route.params.id

        })
          .then(res=>{
            if(res.status==200){
              this.list=res.data?res.data[0]:{}
              this.leader=this.list.leader?this.list.leader:{}
//              this.list=res.data?res.data[0]:{}
              switch (this.list.salary){
                case 1:
                  this.qwxz = '1K-2K';
                  break;
                case 2:
                  this.qwxz = '2K-4K';
                  break;
                case 3:
                  this.qwxz = '4K-6K';
                  break;
                case 4:
                  this.qwxz = '6K-8K';
                  break;
                case 5:
                  this.qwxz = '8K-10K';
                  break;
                case 6:
                  this.qwxz = '10K-15K';
                  break;
                case 7:
                  this.qwxz = '15K-20K';
                  break;
                case 8:
                  this.qwxz = '20K-25K';
                  break;
                case 9:
                  this.qwxz = '25K-35K';
                  break;
                case 10:
                  this.qwxz = '35K-50K';
                  break;
                case 11:
                  this.qwxz = '50K-70K';
                  break;
                case 12:
                  this.qwxz = '70K-100K';
                  break;
                case 13:
                  this.qwxz = '100K以上';
                  break;
                default:
                  this.qwxz = '';
                  break;
              }
            }
          })
          .catch(res=>{
          })
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
  header{
    width: 100%;
    height: 60px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
    z-index: 100;
  }
  header img{
    width: 20px;
    /*height: 20px;*/
  }
  .conmDetail{
    box-shadow: 0px 3px 4px 3px #dedede;
    width: 90%;
    margin: auto;
  }
  .recommendTopSpan{
    font-size: 12px;

    background: #c5f7db;
    color: #44B389;
    padding: 2px 7px;
    border-radius: 8px;
  }
  .salaryDiv{
   border-bottom: solid 1px #dedede;
    /*padding-top: 5px;*/
   padding: 5px 0;
  }
  .cityDiv{
    padding: 9px 0;
  }
  .cityDiv span{
    display: block;
    margin-top: 5px;
  }
  .cityDiv span:last-child{
    font-size: 12px;
    color: #8f8f94;
  }
  .positionHeader p{
    margin-left: 1rem;
    color: #FFFFFF;
  }
  .recommend{
    /*margin-top:5  ;*/
    width: 90%;
    margin:0 auto ;

  }
  .recommendTop{
    display: flex;
    /*justify-content: space-around;*/
    padding-top: 5px;
    justify-content: space-between;
  }
  .recommendG{
    padding-top: 0.8rem;
  }
  .recommendYear{
    background-color: #F5F4F3;
    font-size: 13px;
  }
  .recommendTopK{
    color: #d66c2e;
    font-size: 16px;
    font-weight: 600;
  }
  .personalTop{
    /*border-top:solid 7px #dedede ;*/
    /*border-bottom:solid 7px #dedede ;*/
    width: 90%;
    margin: auto;
  }
  .personalTopS{
    font-size:12px ;
  }
  .personalTopS span{
    background: #f5f2f2;
    padding: 3px;
  }
  .comPosition{
    width: 65px;
    height: 65px;
  }
  .comPosition img{
    width: 100%;
    border-radius: 100%;
  }
  .personalTopNmae{
    display: flex;
    padding: 3px 0;
  }
  .Leader{
    display: flex;
    justify-content: space-between;
    align-items: center;
   }
  .leaderDiv{
    box-shadow: 0px 3px 4px 3px #dedede;
    padding: 10px 12px;
  }
  .LeaderB{
    width: 80px;

    background: #46B789;
    background: linear-gradient(to right, blue, pink);
    color: #FFFFFF;
    text-align: center;
    padding: 7px 0px;
  }
  .LeaderL{
    padding: 10px 0;
    border-top: 1px solid #EAEAEA;

  }
  .LeaderL span{
    display: block;
    padding-top: 2px;
  }
  .bottom{
    display: flex;
    justify-content: space-around;
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 100;
    background: #ffffff; /*底部覆盖不住字*/
  }
  .bottom p{
    width: 40%;
    background: #46B789;
    color: #FFFFFF;
    text-align: center;
    padding: 10px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/comDetailsPosition.vue